/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import { Button } from 'reactstrap';
import classNames from 'classnames';
// eslint-disable-next-line import/extensions
import { IoMdClose } from 'react-icons/io';

type Props = {|
  index: number,
  edpKey: string,
  handleDelete: Function,
  exceedsRequirement: boolean,
|};

const ActionCell = (props: Props): Element<'div'> | null => {
  const { index, edpKey, handleDelete, exceedsRequirement } = props;

  const deleteButton = (
    <div className="text-center" title="Delete">
      <Button
        id={`${index}_DeleteButton`}
        color="link"
        onClick={handleDelete}
        className={classNames('pt-1', 'pb-1', 'pl-2', 'pr-2', 'delete-button', `edp-${edpKey}`)}
      >
        <IoMdClose size="1em" />
      </Button>
    </div>
  );

  return exceedsRequirement ? deleteButton : null;
};

export default ActionCell;
